module.exports = __webpack_public_path__ + "media/ai_video_cartoon2.b69f87f9.mp4";